import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { AccessTime, CalendarMonth, Inventory2 } from "@mui/icons-material";

const MenuDrawer = ({ open, toggleDrawer }) => {
  const { signOut, decoded } = React.useContext(AuthContext);
  const navigate = useNavigate();
  const list = () => (
    <Box
      sx={{ width: 250, marginTop: "2rem" }}
      role="presentation"
      onClick={toggleDrawer}
    >
      <List>
        <ListItem key={"Schedule"} disablePadding>
          <ListItemButton
            onClick={() => navigate(`/shop-schedule?assignedTo=${decoded.id}`)}
          >
            <ListItemIcon>
              <CalendarMonth />
            </ListItemIcon>
            <ListItemText primary={"Schedule"} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem key={"Logout"} disablePadding>
          <ListItemButton
            onClick={() => {
              signOut();
              navigate("/");
            }}
          >
            <ListItemIcon>
              <LogoutOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={"Logout"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        {/* <Button onClick={toggleDrawer()}>{anchor}</Button> */}
        <Drawer anchor={"right"} open={open} onClose={toggleDrawer}>
          {list()}
        </Drawer>
      </React.Fragment>
    </div>
  );
};
export default MenuDrawer;
